import React from 'react';
import { notification, message as antdMessage } from 'antd';
import { connect } from 'react-redux';
import {
  LEVEL_DANGER,
  LEVEL_SUCCESS,
  LEVEL_WARNING,
} from '../../../state/actions/creators/mensajesSistema.actioncreator';

class SystemMessenger extends React.Component {
  componentWillReceiveProps(nextProps) {
    const {
      level, type, title, message,
    } = nextProps;
    if(title ==='' || (title !== this.props.title && level !== this.props.level)) return false;
    const args = { message: title, description: message };
    if (type === 'toast') {
      switch (level) {
        case LEVEL_DANGER:
          antdMessage.error(message);
          break;
        case LEVEL_SUCCESS:
          antdMessage.success(message);
          break;
        case LEVEL_WARNING:
          antdMessage.warning(message);
          break;
        default:
          antdMessage.info(message);
          break;
      }
    } else {
      switch (level) {
        case LEVEL_DANGER:
          notification.error(args);
          break;
        case LEVEL_SUCCESS:
          notification.success(args);
          break;
        case LEVEL_WARNING:
          notification.warning(args);
          break;
        default:
          notification.info(args);
          break;
      }
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <div />;
  }
}

function mapStateToProps({
  mensajesSistema: {
    level, type, title, message, timestamp,
  },
}) {
  return {
    title,
    message,
    timestamp,
    type,
    level,
  };
}
export default connect(mapStateToProps, null)(SystemMessenger);
